import React from 'react';
import { Gift, ShieldCheck } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function OfferBlock() {
  const bonuses = [{
    title: 'Guía de Supervivencia en el BBQ',
    value: '$27'
  }, {
    title: 'Rutina Alpha 5 - Metabolismo en 5 min',
    value: '$35'
  }, {
    title: 'Planificador Paso a Paso 14 Días',
    value: '$27'
  }];
  return <section id="oferta" className="bg-dark-bg text-white py-24 px-4 md:px-8 border-t border-dark-surface" data-id="element-88">
      <div className="max-w-4xl mx-auto" data-id="element-89">
        <div className="text-center mb-12" data-id="element-90">
          <h2 className="font-oswald text-4xl md:text-5xl font-bold mb-6 uppercase" data-id="element-91">
            Todo esto por un{' '}
            <span className="text-brand-orange" data-id="element-92">único pago</span>
          </h2>
        </div>

        <div className="bg-dark-surface rounded-2xl p-8 md:p-12 border-2 border-brand-orange shadow-[0_0_30px_rgba(255,107,53,0.15)] relative" data-id="element-93">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-brand-orange text-white font-oswald font-bold uppercase py-2 px-6 rounded-full text-lg tracking-wider" data-id="element-94">
            Oferta Especial
          </div>

          <div className="text-center mb-10 mt-4" data-id="element-95">
            <h3 className="font-oswald text-2xl font-bold mb-4 uppercase text-gray-400" data-id="element-96">
              Precio de lanzamiento — acceso de por vida
            </h3>
            <div className="flex items-center justify-center gap-4 my-4" data-id="element-97">
              <span className="text-3xl md:text-5xl font-oswald font-bold text-gray-500 line-through" data-id="element-98">
                $17
              </span>
              <span className="text-6xl md:text-8xl font-oswald font-bold text-brand-orange drop-shadow-lg" data-id="element-99">
                $6.39
              </span>
              <span className="text-2xl md:text-4xl font-oswald text-gray-400" data-id="element-100">
                USD
              </span>
            </div>
            <div className="inline-block bg-brand-orange/20 border border-brand-orange/40 rounded-full px-4 py-1 mb-3" data-id="element-101">
              <span className="font-oswald text-brand-orange font-bold text-sm md:text-base uppercase tracking-wider" data-id="element-102">
                🔥 62% de descuento — solo por hoy
              </span>
            </div>
            <p className="font-inter text-gray-400 text-base md:text-lg italic" data-id="element-103">
              Un café en Miami cuesta más que esto. Y no te va a cerrar el
              pantalón.
            </p>
          </div>

          <div className="text-center" data-id="element-104">
            <CTAButton fullWidth className="md:w-3/4 py-5 text-2xl" href="https://pay.hotmart.com/T105939705O" data-id="element-105">
              👉 SÍ, QUIERO EMPEZAR HOY
            </CTAButton>
            <p className="font-inter text-gray-500 mt-6 flex items-center justify-center gap-2" data-id="element-106">
              <ShieldCheck className="w-5 h-5" data-id="element-107" /> Pago seguro · PDF en tu email
              en menos de 2 minutos
            </p>
          </div>
        </div>
      </div>
    </section>;
}